<template>
  <div class="rightContent">
    <div class="title">
      累计学习时间：
      <span>{{ "00:00:00".slice(0, 8 - learnHour.length) + learnHour }}</span>
      累计学时：
      <span>{{ learnCredit }}</span>
      <!--ICRD开放注册允许选课后放开注释启动功能，同时放开后端功能20220308byfgq-->
      <!-- <router-link to="/personal/selectCourse" class="button">选课</router-link>
      <button
        @click="
          payTip = true;
          payStatus = false;
        "
      >
        付费
      </button> -->
      <!--ICRD开放注册允许选课后放开注释启动功能，同时放开后端功能20220308byfgq-->
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 990px">
        <el-table-column
          prop="cid"
          label="课程ID"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cname"
          label="课程名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="vid"
          label="课时ID"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column label="课时名" width="250" align="center">
          <template slot-scope="scope">
            {{ scope.row.videoName }}
            <br />
            <!--ICRD学习期间放开注释，启动功能20220308byfgq；技能培训期间也需要打开20220916byfgq-->
            <!-- <router-link
              :to="{
                name: 'course',
                params: { id: scope.row.cid + 'c' + scope.row.vid },
              }"
              >点击进入学习</router-link
            >  -->
            <!--ICRD学习期间放开注释，启动功能20220308byfgq；技能培训期间也需要打开20220916byfgq-->
          </template>
        </el-table-column>
        <el-table-column
          prop="credit"
          label="学时数"
          width="70"
          align="center"
        ></el-table-column>
        <el-table-column label="全部时长" width="84" align="center">
          <template slot-scope="scope">
            {{
              "00:00:00".slice(0, 8 - scope.row.duration.length) +
              scope.row.duration
            }}
          </template>
        </el-table-column>
        <el-table-column label="已学时长" width="84" align="center">
          <template slot-scope="scope">
            {{
              "00:00:00".slice(0, 8 - scope.row.learnDuration.length) +
              scope.row.learnDuration
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="examFinished"
          label="是否完成考核"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.examFinished === null"
              >无考核，视频全部看完即可获得学分</span
            >
            <span v-if="scope.row.examFinished === true">是</span>
            <span v-if="scope.row.examFinished === false">
              否
              <br />
              <!--ICRD学习期间放开注释，启动功能20220308byfgq-->
              <!-- <router-link
                :to="{ name: 'test', params: { id: scope.row.vid + '0000' } }"
                target="_blank"
                >点击进入考核</router-link
              > -->
              <!--ICRD学习期间放开注释，启动功能20220308byfgq-->
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="learnCredit"
          label="已获学时"
          width="81"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="10"
        prev-text="上一页"
        next-text="下一页"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div id="registerOnly" v-if="payTip">
      <div class="frame" @click.stop>
        <div class="head">
          <img src="/static/logo.png" />
          <span class="zh-remove" @click="payTip = false"></span>
        </div>
        <div class="content" v-if="!payStatus">
          <input type="text" placeholder="请填写剩余学分数量" v-model="scope" />
          <p style="margin-top: 50px; display: inline-block">续费金额</p>
          <span class="selectPay">{{ scope * 20 }}元</span>
          <button @click="_payTip()">立即支付</button>
        </div>
        <div class="content" v-if="payStatus">
          <p style="margin-bottom: 60px; margin-top: 20px; font-size: 16px">
            请在新打开的页面完成支付后,点击下方“已完成”关闭弹框
          </p>
          <button @click="payTip = false">已完成</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageCourseSchedule, baseURL } from "@/assets/js/axios.js";
export default {
  name: "student",
  data() {
    return {
      page: 1,
      row: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      learnHour: 0,
      learnCredit: 0,
      payTip: false,
      payStatus: false,
      scope: ""
    };
  },
  watch: {
    scope(newVal, oldVal) {
      this.scope = newVal.replace(/\D/g, "").substring(0, 3);
    }
  },
  created() {
    this._pageCourseSchedule();
  },
  methods: {
    _payTip() {
      window.open(
        baseURL + "/pay/recharge?amount=" + this.scope * 20,
        "_blank"
      );
      this.payStatus = 1;
    },
    handleSizeChange(val) {
      this.row = val;
      this._pageCourseSchedule();
    },
    handleCurrentChange(val) {
      this.page = val;
      this._pageCourseSchedule();
    },
    _pageCourseSchedule() {
      pageCourseSchedule(this.page, this.row).then((res) => {
        this.tableData = res.data.classSchedules;
        this.learnHour = res.data.learnHour;
        this.learnCredit = res.data.learnCredit;
        this.total = res.data.count;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.rightContent {
  .table {
    /deep/ .el-pagination {
      /deep/ .btn-prev,
      .btn-next {
        min-width: 50px;
      }
    }
     a{
          color: #109eff;
      }
    .title {
      background: #fff;
      height: 46px;
      widows: 984px;
      line-height: 46px;
      padding-left: 26px;
      font-size: 14px;
      color: rgb(102, 102, 102);
      margin-bottom: 12px;
      span {
        color: #1b1f34;
        font-size: 18px;
        padding-right: 26px;
      }
      button {
        font-size: 14px;
        line-height: 22px;
        z-index: 124;
        background: #109eff;
        border: none;
        outline: none;
        color: #fff;
        width: 80px;
        height: 22px;
        border-radius: 4px;
        float: right;
        margin-right: 10px;
        margin-top: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personal/student.vue